import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    visibleActivities: [],
};

export const activitiesSlice = createSlice({
    name: 'activities',
    initialState,
    reducers: {
        setActivities: (state, action) => {
            state.visibleActivities = action.payload;
        },
    },
});

export const { setActivities } = activitiesSlice.actions;

export default activitiesSlice.reducer;
